module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-19-832f2ae60184ed7d2f6fe03ef39616a1.jpg";